import React, { useState } from "react";
import Button from '@mui/material/Button';
import { Form, Modal } from "react-bootstrap";
import axios from "axios";

const UploadModal = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [uploadFile, setUploadFile] = useState({});

  const fileSelectedHandler = (e) => {
    setUploadFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const datA = new FormData();

    datA.append("nida", uploadFile);

    //let accessToken = localStorage.getItem('access_token');
    axios
      .post("http://localhost:3003/nationalid", datA, {
        headers: {
          //'Accept': 'application/json',
          "Content-Type": "multipart/form-data",
          //Authorization: accessToken
        },
      })
      .then((response) => {
        alert("The file is successfully uploaded");
        handleClose();
      })
      .catch((error) => {
        alert("The file is not  uploaded");
      });
  };

  return (
    <>
      <Button
        type="button"
        onClick={handleShow}
        className="showModalButton btn icon-btn btn-warning"
        //onChange={(e) =>{setInputFile(e.target.value)}}
      >
        Edit
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <h5 className="modal-title">Applicant Information</h5>
          </Modal.Title>
        </Modal.Header>
        <div className="row" style={{ padding: "0px 30px 0px 30px" }}>
                UPLOAD HERE
        </div>
        <Modal.Footer>
          <Button
            style={{ background: "#0d47a1", color: "white" }}
            onClick={handleSubmit}
            className="mr-2"
          >
            Update
          </Button>
          <Button
            style={{ background: "#ff4444", color: "white" }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default UploadModal;
